import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, Input, NgZone, OnInit, Output } from '@angular/core';
import { GameOverlayService } from '../../../../../services/game-overlay/game-overlay.service';
import { ChoiceCardComponent } from '../../../../ui/base/choice-card/choice-card.component';
import { AudioService } from '../../../../../services/audio/audio.service';

@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrl: './survey.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SurveyComponent implements OnInit, AfterViewInit {
  @Input()
  personalityTypes: string[];
  @Input()
  questions;
  @Output()
  selectedAnswer: EventEmitter<string> = new EventEmitter();
	hiddenImages: string[] = [];
	currentStep = 0;

	pause = false;

  exclusions = {
    E: 'I',
    I: 'E',
    N: 'S',
    S: 'N',
    T: 'F',
    F: 'T',
    P: 'J',
    J: 'P',
  };

  constructor(
    private zone: NgZone,
    private overlay: GameOverlayService,
    private audio: AudioService
  ) {}
  ngOnInit(): void {
    this.overlay.showSpeaker();
  }

  ngAfterViewInit(): void {
    this.audio.playTestStart();
  }
  selected(type: string) {
    if (this.pause) return;
    
    this.pause = true;

    const types = this.personalityTypes.filter(t => t.indexOf(this.exclusions[type]) !== -1);
    this.hiddenImages.push(...types);
    this.zone.runOutsideAngular(() => {
      setTimeout(() => {
        this.zone.run(() => {
          this.selectedAnswer.emit(type);
          if (this.questions.length === this.currentStep + 1) {
          } else {
            this.currentStep++;
          }
          this.pause = false;
        });
      }, 600);
    });
  }
}
